import { Component, ElementRef } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';
import { FormGroup } from "@angular/forms";
import { Storage } from "@ionic/storage";

@Component({
  selector: 'page-report-terms',
  templateUrl: 'report-terms.html',
})
export class ReportTermsPage {

  form: FormGroup;
  terms = '';

  constructor(
      public navCtrl: NavController,
      public navParams: NavParams,
      public viewCtrl: ViewController,
      public storage: Storage,
      public elem: ElementRef
  ) {
    this.form = navParams.get('form');
    this.storage.get('customer_terms').then((val) => {
      this.terms = val;
    }).catch((err) => {
      console.error(JSON.stringify(err));
    });
  }

  acceptTerms(){
    this.form.get('terms_agreed').setValue(true);
    this.form.get('time_agreed').setValue(Math.floor(new Date().getTime()/1000));
    this.closeModal();
  }

  closeModal(){
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/report-terms/report-terms.ts